import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  TextField,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Typography,
  Checkbox,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  getDealerProfile,
  getDealersData,
  getDistrictMaster,
  getStatesMaster,
} from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import authAxios from "setups/axios";
import moment from "moment";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "80%",
  overflowY: "auto",
  padding: "1rem",
  bgcolor: "background.paper",
  color: "text.primary",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

const DealerProfile = ({
  openDealerProfile,
  handleDealerProfileClose,
  dealerProfile,
  dealerType,
}) => {
  const [profileData, setProfileData] = useState({
    companyDetails: {
      companyName: "",
      ownerName: "",
      companyType: "",
      designation: "",
      mobileNo: "",
      whatsappNo: "",
      phoneNo: "",
      email: "",
      gst: "",
      pan: "",
      address: "",
      state: "",
      city: "",
      pinCode: "",
    },
    primaryContactDetails: {
      contactPerson: "",
      contactNo: "",
      email: "",
      whatsappNo: "",
      designation: "",
    },
    communicationDetails: {
      address: "",
      state: "",
      city: "",
      pinCode: "",
    },
    personalDetails: {
      homeAddress: "",
      dateofBirth: "",
      education: "",
      languages: [],
      maritalStatus: "",
      dateofAnniversary: "2023",
      spouseName: "",
      spouseDOB: "2023",
      child1name: "",
      child1dob: "2023",
      child2name: "",
      child2dob: "2023",
      childrens: [],
    },
    socailDetails: {
      facebook: "",
      instagram: "",
      website: "",
    },
  });

  const [languages, setLanguages] = useState([]);

  const [vehicleDetails, setVehicleDetails] = useState({
    // truckDetails: {
    //   application: [],
    //   loadingPattern: "",
    //   avgLeadDistance: "",
    //   avgMonthlyRunning: "",
    //   vehicles: [{ name: "", count: "" }],
    //   totalWheels: "",
    // },
    // busDetails: {
    //   application: [],
    //   loadingPattern: "",
    //   avgLeadDistance: "",
    //   avgMonthlyRunning: "",
    //   vehicles: [{ name: "", count: "" }],
    //   totalWheels: "",
    // },
    lcvDetails: {
      application: [],
      loadingPattern: "",
      avgLeadDistance: "",
      avgMonthlyRunning: "",
      vehicles: [
        { name: "", count: "" },
        { name: "", count: "" },
      ],
      totalWheels: "",
    },
    retread: {
      retreadPractice: "",
      majorTradeUsed: "",
      retreadFranchise: "",
      tyresRetreadMonth: "",
    },
  });

  const [lcv, setLcv] = useState({
    application: [],
    loadingPattern: "",
    avgLeadDistance: "",
    avgMonthlyRunning: "",
    vehicles: [
      { name: "lcv4W", count: 0, label: "4 Wheeler" },
      { name: "lcv6W", count: 0, label: "6 Wheeler" },
      { name: "scv4W", count: 0, label: "4 Wheeler SCV" },
      { name: "pickup4W", count: 0, label: "4 Wheeler Pickup" },
    ],
    totalWheels: "",
  });

  const [bus, setBus] = useState({
    application: [],
    loadingPattern: "",
    avgLeadDistance: "",
    avgMonthlyRunning: "",
    vehicles: [
      { name: "bus6W", count: "", label: "6 Wheeler" },
      { name: "bus10W", count: "", label: "10 Wheeler" },
    ],
    totalWheels: "",
  });

  const [truck, setTruck] = useState({
    application: [],
    loadingPattern: "",
    avgLeadDistance: "",
    avgMonthlyRunning: "",
    vehicles: [
      { name: "truck6W", count: "", label: "6 Wheeler" },
      { name: "truck8W", count: "", label: "8 Wheeler" },
      { name: "truck10W", count: "", label: "10 Wheeler" },
      { name: "truck12W", count: "", label: "12 Wheeler" },
      { name: "truck14W", count: "", label: "14 Wheeler" },
      { name: "truck16W", count: "", label: "16 Wheeler" },
      { name: "truck18W", count: "", label: "18 Wheeler" },
      { name: "truck22W", count: "", label: "22 Wheeler" },
      ,
    ],
    totalWheels: "",
  });

  const [retreadData, setRetread] = useState({
    retreadPractice: "",
    majorTradeUsed: "",
    retreadFranchise: "",
    tyresRetreadMonth: "",
  });

  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [stateList1, setStateList1] = useState([]);
  const [cityList1, setCityList1] = useState([]);

  const handleKeyPress = (e) => {
    const allowedCharacters = /^[0-9]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleEmailKeyPress = (e) => {
    const allowedCharacters = /^[a-zA-Z0-9@._]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "@" && e.target.value.includes("@")) {
      e.preventDefault();
    }
  };

  const handleMobileKeyPress = (e) => {
    const allowedCharacters = /^[0-9]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.value.length >= 10) {
      e.preventDefault();
    }
  };

  const handlepanKeyPress = (e) => {
    let inputValue = e.target.value + String.fromCharCode(e.charCode);

    let panRegex = /^[A-Z]{0,5}[0-9]{0,4}[A-Z]{0,1}$/;

    if (!panRegex.test(inputValue)) {
      e.preventDefault();
    }
  };

  // const handlegstKeyPress = (e) => {
  //   const allowedCharacters = /^[0-9A-Z]+$/;
  //   const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}\d{1}$/;

  //   if (!allowedCharacters.test(e.key)) {
  //     e.preventDefault();
  //   }

  //   const combinedValue = e.target.value + e.key;

  //   if (!gstRegex.test(combinedValue) || combinedValue.length > 15) {
  //     e.preventDefault();
  //   }
  // };

  const [expanded, setExpanded] = useState(Object.keys(profileData));

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(
      isExpanded
        ? [...expanded, panel]
        : expanded.filter((item) => item !== panel)
    );
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const [section, fieldName] = name.split(".");
    setProfileData({
      ...profileData,
      [section]: {
        ...profileData[section],
        [fieldName]: value,
      },
    });
  };

  useEffect(async () => {
    await getStatesMaster()
      .then((d) => {
        setStateList(d?.data);
        setStateList1(d?.data);
      })
      .catch((err) => {
        toastMessage("error fetching data", "error");
      });
  }, []);

  useEffect(async () => {
    await getDistrictMaster(profileData?.companyDetails?.state)
      .then((d) => {
        setCityList(d?.data);
      })
      .catch((err) => {
        toastMessage("error fetching data", "error");
      });
  }, [profileData?.companyDetails?.state]);

  useEffect(async () => {
    await getDistrictMaster(profileData?.communicationDetails?.state)
      .then((d) => {
        setCityList1(d?.data);
      })
      .catch((err) => {
        toastMessage("error fetching data", "error");
      });
  }, [profileData?.communicationDetails?.state]);

  useEffect(async () => {
    await getDealerProfile(dealerProfile)
      .then((d) => {
        const responseData = d?.data?.data;
        setProfileData((prevProfileData) => {
          return {
            ...prevProfileData,
            companyDetails: {
              ...prevProfileData.companyDetails,
              ...responseData.companyDetails,
            },
            personalDetails: {
              ...prevProfileData.personalDetails,
              ...responseData.personalDetails,
              dateofBirth: moment
                .utc(responseData.personalDetails?.dateofBirth)
                .format("YYYY-MM-DD"),
              dateofAnniversary: moment
                .utc(responseData.personalDetails?.dateofAnniversary)
                .format("YYYY-MM-DD"),
              child1name: responseData?.personalDetails?.childrens[0]
                ? responseData?.personalDetails?.childrens[0]?.name
                : "",

              child2name: responseData?.personalDetails?.childrens[1]
                ? responseData?.personalDetails?.childrens[1]?.name
                : "",

              child1dob: responseData?.personalDetails?.childrens[0]?.childDOB
                ? moment
                    .utc(responseData?.personalDetails?.childrens[0]?.childDOB)
                    .format("YYYY-MM-DD")
                : "2023",
              spouseDOB: responseData?.personalDetails?.spouseDOB
                ? moment
                    .utc(responseData?.personalDetails?.spouseDOB)
                    .format("YYYY-MM-DD")
                : "2023",

              child2dob: responseData?.personalDetails?.childrens[1]?.childDOB
                ? moment
                    .utc(responseData?.personalDetails?.childrens[1]?.childDOB)
                    .format("YYYY-MM-DD")
                : "2023",
            },
            primaryContactDetails: {
              ...prevProfileData?.primaryContactDetails,
              ...responseData?.primaryContactDetails,
            },

            communicationDetails: {
              ...prevProfileData?.communicationDetails,
              ...responseData?.communicationDetails,
            },

            socailDetails: {
              ...prevProfileData?.socailDetails,
              ...responseData?.socailDetails,
            },
          };
        });

        let arr = lcv?.vehicles;
        let newarr = responseData?.vehicleDetails?.lcvDetails?.vehicles;
        newarr.forEach((newItem) => {
          const index = arr.findIndex((item) => item.name === newItem.name);
          if (index !== -1) {
            arr[index].count = newItem.count;
          }
        });

        let arrbus = bus?.vehicles;
        let newarrbus = responseData?.vehicleDetails?.busDetails?.vehicles;
        newarrbus.forEach((newItem) => {
          const index = arrbus.findIndex((item) => item.name === newItem.name);
          if (index !== -1) {
            arrbus[index].count = newItem.count;
          }
        });

        let arrtruck = truck?.vehicles;
        let newarrtruck = responseData?.vehicleDetails?.truckDetails?.vehicles;
        newarrtruck.forEach((newItem) => {
          const index = arrtruck.findIndex(
            (item) => item.name === newItem.name
          );
          if (index !== -1) {
            arrtruck[index].count = newItem.count;
          }
        });

        setLcv({
          ...lcv,
          ...responseData.vehicleDetails.lcvDetails,
          vehicles: arr,
        });

        setBus({
          ...lcv,
          ...responseData.vehicleDetails.busDetails,
          vehicles: arrbus,
        });

        setTruck({
          ...lcv,
          ...responseData.vehicleDetails.truckDetails,
          vehicles: arrtruck,
        });

        setRetread({
          ...retreadData,
          ...responseData?.vehicleDetails?.retread,
        });

        setTotalSumLcv(responseData?.vehicleDetails.lcvDetails?.totalWheels);
        setTotalSumBus(responseData?.vehicleDetails.busDetails?.totalWheels);
        setTotalSumtruck(
          responseData?.vehicleDetails.truckDetails?.totalWheels
        );
      })
      .catch((err) => {
        console.log("err12", err);
      });
  }, [dealerProfile]);

  const fieldSchema = {
    companyDetails: {
      companyName: { label: "Company Name", type: "text", disabled: true },
      ownerName: { label: "Owner Name", type: "text", disabled: true },
      companyType: {
        label: "Company Type",
        type: "text",
        dropdown: true,
        options: ["Proprietor", "Partnership", "Private Limited", "Limited"],
      },
      designation: {
        label: "Designation",
        type: "text",
      },
      mobileNo: {
        label: "Mobile No",
        type: "text",
        handle: handleMobileKeyPress,
        disabled: true,
      },
      whatsappNo: {
        label: "Whatsapp No",
        type: "text",
        handle: handleMobileKeyPress,
      },
      phoneNo: {
        label: "Phone No",
        type: "text",
        handle: handleMobileKeyPress,
      },
      email: { label: "Email", type: "email", handle: handleEmailKeyPress },
      gst: { label: "GST Number", type: "text", disabled: true },
      pan: { label: "PAN Card", type: "text", handle: handlepanKeyPress },
      address: { label: "Address", type: "text" },
      state: {
        label: "State",
        type: "text",
        dropdown: true,
        options: stateList?.map((res) => res?.name),
      },
      city: {
        label: "City",
        type: "text",
        dropdown: true,
        options: cityList?.map((res) => res?.name),
      },
      pinCode: { label: "Pincode", type: "text" },
    },
    primaryContactDetails: {
      contactPerson: { label: "Contact Person", type: "text" },
      contactNo: {
        label: "Contact No",
        type: "text",
        handle: handleMobileKeyPress,
      },
      email: { label: "Email", type: "text", handle: handleEmailKeyPress },
      whatsappNo: {
        label: "Whatsapp No",
        type: "text",
        handle: handleMobileKeyPress,
      },
      designation: {
        label: "Designation",
        type: "text",
      },
    },
    communicationDetails: {
      address: { label: "Address", type: "text" },
      state: {
        label: "State",
        type: "text",
        dropdown: true,
        options: stateList1?.map((res) => res?.name),
      },
      city: {
        label: "City",
        type: "text",
        dropdown: true,
        options: cityList1?.map((res) => res?.name),
      },
      pinCode: { label: "Pincode", type: "text" },
    },
    personalDetails: {
      homeAddress: { label: "Home Address", type: "text" },
      dateofBirth: { label: "Date of Birth", type: "date" },
      education: {
        label: "Education",
        type: "text",
        dropdown: true,
        options: ["10+", "12+", "GRADUATION", "POST_GRADUATION", "NA"],
      },
      languages: {
        label: "Languages Known",
        type: "text",
        // dropdown: true,
        options: [
          "Hindi",
          "English",
          "Gujarati",
          "Kannada",
          "Malayalam",
          "Marathi",
          "Pubjabi",
          "Sindhi",
          "Telugu",
          "Tamil",
        ],
        multiSelect: true,
      },
      maritalStatus: {
        label: "Marital Status",
        type: "text",
        dropdown: true,
        options: ["married", "unmarried"],
      },
      dateofAnniversary: { label: "Anniversary Date", type: "date" },
      spouseName: { label: "Spouse Name", type: "text" },
      spouseDOB: { label: "Spouse DOB", type: "date" },
      child1name: { label: "Child 1 Name", type: "text" },
      child1dob: { label: "Child 1 DOB", type: "date" },
      child2name: { label: "Child 2 Name", type: "text" },
      child2dob: { label: "Child 2 DOB", type: "date" },
      childrens: { label: "remove", type: "date" },
    },
    socailDetails: {
      facebook: { label: "Facebook Page", type: "text" },
      instagram: { label: "Instagram Page", type: "text" },
      website: { label: "Website", type: "text" },
    },
  };

  let avgMonthRun = [
    "2k - 3k",
    "3k - 4k",
    "4k - 5k",
    "5k - 6k",
    "6k - 7k",
    "7k - 8k",
    "8k - 9k",
    "9k - 10k",
    "10k - 12k",
    "12k - 15k",
    "15k - 20k",
    ">20k",
  ];

  let applicationList = [
    "Car Carrier",
    "2W Carrier",
    "Tanker",
    "Cement Carrier",
    "Bulker - Fly Ash",
    "Iron/Steel Carrier",
    "Mining Dumper",
    "Ecom Containers",
    "Market Load Containers",
    "ODC",
    "Other",
  ];

  let loadPattern = [
    "Normal (100%)",
    "Moderate (101% to 140%)",
    "Heavy (141% to 160%)",
    "Super Heavy (160%)",
  ];

  let avgLeadDist = [
    "Short (0-100 KMs)",
    "Medium (100-500 KMs)",
    "Long (>500 KMs)",
  ];

  let retreadPractice = ["Retreads", "Sells Cassing"];

  let majorretread = ["JK Tyre", "Apollo", "MRF", "TVS", "Other"];

  const handleSave = async () => {
    let data = profileData;
    let vehicleDetails = {
      lcvDetails: { ...lcv, totalWheels: totalSumLcv },
      busDetails: { ...bus, totalWheels: totalSumBus },
      truckDetails: { ...truck, totalWheels: totalSumtruck },
    };

    data.personalDetails.childrens = [];

    for (let i = 1; i <= 2; i++) {
      let childName = data.personalDetails[`child${i}name`];
      let childDOB = data.personalDetails[`child${i}dob`];

      if (childName && childDOB) {
        data.personalDetails.childrens.push({
          name: childName,
          childDOB: childDOB,
        });
      }
    }
    if (dealerType === "FM") {
      for (const key in vehicleDetails) {
        if (Object.hasOwnProperty.call(vehicleDetails, key)) {
          const section = vehicleDetails[key];
          section.vehicles = section.vehicles.filter(
            (vehicle) => vehicle && vehicle.count !== ""
          );
          section.application = section.application.filter(
            (entry) => entry !== ""
          );
        }
      }
      console.log("final1", vehicleDetails);
    }
    for (const key in data) {
      if (typeof data[key] === "object" && !Array.isArray(data[key])) {
        data[key] = Object.fromEntries(
          Object.entries(data[key]).filter(([_, value]) => value !== "")
        );
      }
    }

    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length === 0) {
        delete data[key];
      }
    });

    let dataobj;
    if (dealerType === "FM") {
      dataobj = {
        ...data,
        Kunnr: dealerProfile,
        vehicleDetails: { ...vehicleDetails, retread: retreadData },
      };
    } else {
      dataobj = {
        ...data,
        Kunnr: dealerProfile,
      };
    }

    await authAxios()({
      url: `/api/v1/dealers/profile`,
      method: "POST",
      data: dataobj,
    })
      .then((res) => {
        handleDealerProfileClose();
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage(err?.data?.message, "success");
      });
  };

  const convertCamelCaseToSpaceSeparated = (fieldName) => {
    const spacedString = fieldName.replace(/([A-Z])/g, " $1").trim();
    return spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
  };

  const handleChangeVehicle = (event) => {
    const { name, value } = event.target;
    const [sectionName, fieldName, index, vehicleFieldName] = name.split(".");

    if (vehicleFieldName) {
      // If the field belongs to a vehicle, update the vehicle details
      setVehicleDetails((prevState) => ({
        ...prevState,
        [sectionName]: {
          ...prevState[sectionName],
          vehicles: prevState[sectionName].vehicles.map((vehicle, idx) => {
            if (idx.toString() === index) {
              return {
                ...vehicle,
                [vehicleFieldName]: value,
              };
            }
            return vehicle;
          }),
        },
      }));
    } else {
      // If the field belongs to the section, update the section details
      setVehicleDetails((prevState) => ({
        ...prevState,
        [sectionName]: {
          ...prevState[sectionName],
          [fieldName]: value,
        },
      }));
    }
  };

  const [totalSumBus, setTotalSumBus] = useState(0);
  const [totalSumLcv, setTotalSumLcv] = useState(0);
  const [totalSumtruck, setTotalSumtruck] = useState(0);

  const [totalCountBus, setTotalCountBus] = useState(0);
  const [totalCountLcv, setTotalCountLcv] = useState(0);
  const [totalCounttruck, setTotalCounttruck] = useState(0);

  useEffect(() => {
    let sum = bus?.vehicles.reduce((acc, item) => {
      if (item.count !== "") {
        const countValue = parseInt(item.count);
        const numberFromName = parseInt(item.name.match(/\d+/)[0]);
        acc += countValue * numberFromName;
      }
      return acc;
    }, 0);
    let count = bus?.vehicles.reduce((acc, item) => {
      if (item.count !== "") {
        const countValue = parseInt(item?.count);
        acc += countValue;
      }
      return acc;
    }, 0);
    setTotalSumBus(sum);
    setTotalCountBus(count);
  }, [bus]);

  useEffect(() => {
    if (lcv?.vehicles.length > 0) {
      let sum = lcv?.vehicles.reduce((acc, item) => {
        if (item?.count !== "") {
          const countValue = parseInt(item.count);
          const numberFromName = parseInt(item.name.match(/\d+/)[0]);
          acc += countValue * numberFromName;
        }
        return acc;
      }, 0);
      let count = lcv?.vehicles.reduce((acc, item) => {
        if (parseInt(item?.count) > 0) {
          const countValue = parseInt(item?.count);
          acc += countValue;
        }
        return acc;
      }, 0);
      setTotalSumLcv(sum);
      setTotalCountLcv(count);
    }
  }, [lcv]);

  useEffect(() => {
    let sum = truck?.vehicles?.reduce((acc, item) => {
      if (item.count !== "") {
        const countValue = parseInt(item?.count);
        const numberFromName = parseInt(item.name.match(/\d+/)[0]);
        acc += countValue * numberFromName;
      }
      return acc;
    }, 0);
    let count = truck?.vehicles.reduce((acc, item) => {
      if (item.count !== "") {
        const countValue = parseInt(item?.count);
        acc += countValue;
      }
      return acc;
    }, 0);
    setTotalSumtruck(sum);
    setTotalCounttruck(count);
  }, [truck]);


  const handleVehicleChange = (e, type) => {
    const { name, value } = e.target;

    if (type === "lcv") {
      const updatedVehicles = lcv.vehicles.map((vehicle) =>
        vehicle.name === name ? { ...vehicle, count: value } : vehicle
      );

      setLcv((prevState) => ({
        ...prevState,
        vehicles: updatedVehicles,
      }));
    }
    if (type === "bus") {
      const updatedVehicles = bus.vehicles.map((vehicle) =>
        vehicle.name === name ? { ...vehicle, count: value } : vehicle
      );

      setBus((prevState) => ({
        ...prevState,
        vehicles: updatedVehicles,
      }));
    }
    if (type === "truck") {
      const updatedVehicles = truck.vehicles.map((vehicle) =>
        vehicle.name === name ? { ...vehicle, count: value } : vehicle
      );

      setTruck((prevState) => ({
        ...prevState,
        vehicles: updatedVehicles,
      }));
    }
  };

  const handleRetreadChange = (e) => {
    const { name, value } = e.target;

    setRetread((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleVehicleChange1 = (e, type) => {
    const { name, value } = e.target;
    if (name === "application" && type === "lcv") {
      setLcv((prevState) => ({
        ...prevState,
        application: [value],
      }));
    }
    if (name === "application" && type === "bus") {
      setBus((prevState) => ({
        ...prevState,
        application: [value],
      }));
    }
    if (name === "application" && type === "truck") {
      setTruck((prevState) => ({
        ...prevState,
        application: [value],
      }));
    }

    if (type === "lcv" && name !== "application") {
      setLcv((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if (type === "bus" && name !== "application") {
      setBus((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
    if (type === "truck" && name !== "application") {
      setTruck((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  console.log("profile123", profileData);

  const handleLanguage = (lang) => {
    // if (languages.includes(lang)) {
    //   setLanguages((prevState) => prevState.filter((item) => item !== lang));
    // } else {
    //   setLanguages((prevState) => [...prevState, lang]);
    // }

    if (profileData.personalDetails.languages.includes(lang)) {
      setProfileData((prevState) => ({
        ...prevState,
        personalDetails: {
          ...prevState.personalDetails,
          languages: prevState.personalDetails.languages.filter(
            (item) => item !== lang
          ),
        },
      }));
    } else {
      setProfileData((prevState) => ({
        ...prevState,
        personalDetails: {
          ...prevState.personalDetails,
          languages: [...prevState.personalDetails.languages, lang],
        },
      }));
    }
  };

  const handleApplication = (e, type) => {
    const { name, value } = e.target;
    if (type === "lcv") {
      if (lcv?.application.includes(name)) {
        setLcv((prevState) => ({
          ...prevState,
          application: prevState.application.filter((item) => item !== name),
        }));
      } else {
        setLcv((prevState) => ({
          ...prevState,
          application: [...prevState.application, name],
        }));
      }
    }
    if (type === "bus") {
      if (bus?.application.includes(name)) {
        setBus((prevState) => ({
          ...prevState,
          application: prevState.application.filter((item) => item !== name),
        }));
      } else {
        setBus((prevState) => ({
          ...prevState,
          application: [...prevState.application, name],
        }));
      }
    }
    if (type === "truck") {
      if (truck?.application.includes(name)) {
        setTruck((prevState) => ({
          ...prevState,
          application: prevState.application.filter((item) => item !== name),
        }));
      } else {
        setTruck((prevState) => ({
          ...prevState,
          application: [...prevState.application, name],
        }));
      }
    }
  };

  return (
    <Modal open={open} onClose={handleDealerProfileClose}>
      <Box sx={messageStyle}>
        <h2>Dealer Profile</h2>
        <form style={{ marginTop: "2rem" }}>
          {Object.entries(profileData).map(([sectionName, sectionFields]) => (
            <Accordion
              key={sectionName}
              expanded={expanded.includes(sectionName)}
              onChange={handleAccordionChange(sectionName)}
              style={{ margin: "1rem 0" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${sectionName}-content`}
                id={`${sectionName}-header`}
              >
                <Typography>
                  {sectionName === "socailDetails"
                    ? convertCamelCaseToSpaceSeparated("socialDetails")
                    : convertCamelCaseToSpaceSeparated(sectionName)}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gap: "20px",
                    width: "100%",
                  }}
                >
                  {Object.entries(sectionFields).map(
                    ([fieldName, fieldValue]) => {
                      const fieldConfig = fieldSchema[sectionName][fieldName];
                      if (fieldConfig?.dropdown) {
                        return (
                          <FormControl key={fieldName} fullWidth>
                            <InputLabel>{fieldConfig?.label}</InputLabel>
                            <Select
                              name={`${sectionName}.${fieldName}`}
                              value={fieldValue}
                              onChange={handleChange}
                              style={{ textAlign: "left" }}
                            >
                              {fieldConfig.options.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        );
                      } else if (fieldConfig?.label === "remove") {
                        return;
                      } else if (fieldConfig?.multiSelect) {
                        return (
                          <FormControl key={fieldName} fullWidth>
                            <InputLabel>{fieldConfig?.label}</InputLabel>
                            <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              multiple
                              value={fieldValue}
                              style={{ textAlign: "left" }}
                              renderValue={(fieldValue) => {
                                const data = fieldValue.map((n) => n);
                                return data.join(", ");
                              }}
                            >
                              {fieldConfig.options &&
                              fieldConfig.options?.length > 0 ? (
                                fieldConfig.options.map((r) => (
                                  <div key={r} style={{ marginLeft: "1rem" }}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={
                                            fieldValue.find((s) => {
                                              return s == r;
                                            })
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => handleLanguage(r)}
                                          name={r}
                                        />
                                      }
                                      label={`${r}`}
                                    />
                                  </div>
                                ))
                              ) : (
                                <CircularProgress />
                              )}
                            </Select>
                          </FormControl>
                        );
                      } else {
                        return (
                          // if()
                          <>
                            {console.log(
                              "fieldvalue",
                              `${sectionName}.${fieldName}`,
                              fieldValue
                            )}
                            <TextField
                              key={fieldName}
                              label={fieldConfig?.label}
                              type={fieldConfig?.type}
                              name={`${sectionName}.${fieldName}`}
                              value={fieldValue}
                              onChange={handleChange}
                              onKeyPress={fieldConfig?.handle}
                              disabled={
                                fieldConfig?.disabled
                                  ? fieldValue === ""
                                    ? false
                                    : true
                                  : false
                              }
                              fullWidth
                            />
                          </>
                        );
                      }
                    }
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          ))}

          {/* {Object.entries(vehicleDetails).map(
            ([sectionName, sectionFields]) => (
              <Accordion
                key={sectionName}
                expanded={expanded.includes(sectionName)}
                onChange={handleAccordionChange(sectionName)}
                style={{ margin: "1rem 0" }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`${sectionName}-content`}
                  id={`${sectionName}-header`}
                >
                  <Typography>
                    {convertCamelCaseToSpaceSeparated(sectionName)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "20px",
                      width: "100%",
                    }}
                  >
                    {Object.entries(sectionFields).map(
                      ([fieldName, fieldValue]) => {
                        const fieldConfig =
                          vehicleFieldSchema[sectionName][fieldName];
                        if (fieldName === "vehicles") {
                          return fieldValue.map((vehicle, index) => (
                            <div key={index}>
                              {Object.entries(vehicle).map(
                                ([vehicleFieldName, vehicleFieldValue]) => (
                                  <TextField
                                    key={vehicleFieldName}
                                    label={
                                      vehicleFieldSchema[sectionName][
                                        fieldName
                                      ][index][vehicleFieldName].label
                                    }
                                    type={
                                      vehicleFieldSchema[sectionName][
                                        fieldName
                                      ][index][vehicleFieldName].type
                                    }
                                    name={`${sectionName}.${fieldName}[${index}].${vehicleFieldName}`}
                                    value={vehicleFieldValue}
                                    onChange={handleChangeVehicle}
                                    fullWidth
                                  />
                                )
                              )}
                            </div>
                          ));
                        } else if (fieldConfig?.dropdown) {
                          return (
                            <FormControl key={fieldName} fullWidth>
                              <InputLabel>{fieldConfig?.label}</InputLabel>
                              <Select
                                name={`${sectionName}.${fieldName}`}
                                value={fieldValue}
                                onChange={handleChangeVehicle}
                                style={{ textAlign: "left" }}
                              >
                                {fieldConfig.options.map((option) => (
                                  <MenuItem key={option} value={option}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          );
                        } else {
                          return (
                            <TextField
                              key={fieldName}
                              label={fieldConfig?.label}
                              type={fieldConfig?.type}
                              name={`${sectionName}.${fieldName}`}
                              value={fieldValue}
                              onChange={handleChangeVehicle}
                              fullWidth
                            />
                          );
                        }
                      }
                    )}
                  </div>
                </AccordionDetails>
              </Accordion>
            )
          )} */}

          {dealerType === "FM" ? (
            <>
              <Typography
                variant="h4"
                style={{ marginTop: "2rem", textDecoration: "underline" }}
              >
                Vehicle Details
              </Typography>
              <Accordion style={{ margin: "1rem 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`lcv-content`}
                  id={`lcv-header`}
                >
                  <Typography>LCV / SCV / PICKUP</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "20px",
                      width: "100%",
                    }}
                  >
                    {/* <FormControl fullWidth>
                      <InputLabel>{"Application"}</InputLabel>
                      <Select
                        name={"application"}
                        value={lcv.application}
                        onChange={(e) => handleVehicleChange1(e, "lcv")}
                        style={{ textAlign: "left" }}
                      >
                        {applicationList.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl> */}
                    <FormControl key="Application" fullWidth>
                      <InputLabel>Application</InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        name={"application"}
                        value={lcv?.application}
                        style={{ textAlign: "left" }}
                        renderValue={() => {
                          const data = lcv?.application.map((n) => n);
                          return data.join(", ");
                        }}
                      >
                        {applicationList && applicationList?.length > 0 ? (
                          applicationList.map((r) => (
                            <div key={r} style={{ marginLeft: "1rem" }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      lcv?.application.find((s) => {
                                        return s == r;
                                      })
                                        ? true
                                        : false
                                    }
                                    onChange={(e) =>
                                      handleApplication(e, "lcv")
                                    }
                                    name={r}
                                  />
                                }
                                label={`${r}`}
                              />
                            </div>
                          ))
                        ) : (
                          <CircularProgress />
                        )}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>{"Loading Pattern"}</InputLabel>
                      <Select
                        name={"loadingPattern"}
                        value={lcv.loadingPattern}
                        onChange={(e) => handleVehicleChange1(e, "lcv")}
                        style={{ textAlign: "left" }}
                      >
                        {loadPattern.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Lead Distance"}</InputLabel>
                      <Select
                        name={"avgLeadDistance"}
                        value={lcv?.avgLeadDistance}
                        onChange={(e) => handleVehicleChange1(e, "lcv")}
                        style={{ textAlign: "left" }}
                      >
                        {avgLeadDist.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Monthly Running"}</InputLabel>
                      <Select
                        name={"avgMonthlyRunning"}
                        value={lcv.avgMonthlyRunning}
                        onChange={(e) => handleVehicleChange1(e, "lcv")}
                        style={{ textAlign: "left" }}
                      >
                        {avgMonthRun.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      marginTop: "1rem",
                    }}
                  >
                    {lcv?.vehicles &&
                      lcv?.vehicles.map((item, idx) => (
                        <div style={{ display: "flex" }}>
                          {console.log("lcv", item)}
                          <Typography
                            variant="h6"
                            sx={{ p: 1 }}
                            style={{ textAlign: "left", width: "50%" }}
                          >
                            {item?.label}
                          </Typography>
                          <TextField
                            label={"Vehicle Count"}
                            type="text"
                            name={`${item?.name}`}
                            value={item?.count}
                            onChange={(e) => handleVehicleChange(e, "lcv")}
                            fullWidth
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Vehicles :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalCountLcv}
                      </Typography>
                    </div>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Tyres :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalSumLcv}
                      </Typography>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion style={{ margin: "1rem 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`lcv-content`}
                  id={`lcv-header`}
                >
                  <Typography>BUS</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "20px",
                      width: "100%",
                    }}
                  >
                    <FormControl key="Application" fullWidth>
                      <InputLabel>Application</InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        name={"application"}
                        value={bus?.application}
                        style={{ textAlign: "left" }}
                        renderValue={() => {
                          const data = bus?.application.map((n) => n);
                          return data.join(", ");
                        }}
                      >
                        {applicationList && applicationList?.length > 0 ? (
                          applicationList.map((r) => (
                            <div key={r} style={{ marginLeft: "1rem" }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      bus?.application.find((s) => {
                                        return s == r;
                                      })
                                        ? true
                                        : false
                                    }
                                    onChange={(e) =>
                                      handleApplication(e, "bus")
                                    }
                                    name={r}
                                  />
                                }
                                label={`${r}`}
                              />
                            </div>
                          ))
                        ) : (
                          <CircularProgress />
                        )}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>{"Loading Pattern"}</InputLabel>
                      <Select
                        name={"loadingPattern"}
                        value={bus?.loadingPattern}
                        onChange={(e) => handleVehicleChange1(e, "bus")}
                        style={{ textAlign: "left" }}
                      >
                        {loadPattern.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Lead Distance"}</InputLabel>
                      <Select
                        name={"avgLeadDistance"}
                        value={bus?.avgLeadDistance}
                        onChange={(e) => handleVehicleChange1(e, "bus")}
                        style={{ textAlign: "left" }}
                      >
                        {avgLeadDist.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Monthly Running"}</InputLabel>
                      <Select
                        name={"avgMonthlyRunning"}
                        value={bus.avgMonthlyRunning}
                        onChange={(e) => handleVehicleChange1(e, "bus")}
                        style={{ textAlign: "left" }}
                      >
                        {avgMonthRun.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      marginTop: "1rem",
                    }}
                  >
                    {bus?.vehicles &&
                      bus?.vehicles.map((item, idx) => (
                        <div style={{ display: "flex" }}>
                          <Typography
                            variant="h6"
                            sx={{ p: 1 }}
                            style={{ textAlign: "left", width: "50%" }}
                          >
                            {item.label}
                          </Typography>
                          <TextField
                            label={"Vehicle Count"}
                            type="text"
                            name={`${item?.name}`}
                            value={item?.count}
                            onChange={(e) => handleVehicleChange(e, "bus")}
                            fullWidth
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Vehicles :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalCountBus}
                      </Typography>
                    </div>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Tyres :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalSumBus}
                      </Typography>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion style={{ margin: "1rem 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`lcv-content`}
                  id={`lcv-header`}
                >
                  <Typography>TRUCK (ICV / MHCV)</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "20px",
                      width: "100%",
                    }}
                  >
                    <FormControl key="Application" fullWidth>
                      <InputLabel>Application</InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        name={"application"}
                        value={truck?.application}
                        style={{ textAlign: "left" }}
                        renderValue={() => {
                          const data = truck?.application.map((n) => n);
                          return data.join(", ");
                        }}
                      >
                        {applicationList && applicationList?.length > 0 ? (
                          applicationList.map((r) => (
                            <div key={r} style={{ marginLeft: "1rem" }}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      truck?.application.find((s) => {
                                        return s == r;
                                      })
                                        ? true
                                        : false
                                    }
                                    onChange={(e) =>
                                      handleApplication(e, "truck")
                                    }
                                    name={r}
                                  />
                                }
                                label={`${r}`}
                              />
                            </div>
                          ))
                        ) : (
                          <CircularProgress />
                        )}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>{"Loading Pattern"}</InputLabel>
                      <Select
                        name={"loadingPattern"}
                        value={truck.loadingPattern}
                        onChange={(e) => handleVehicleChange1(e, "truck")}
                        style={{ textAlign: "left" }}
                      >
                        {loadPattern.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Lead Distance"}</InputLabel>
                      <Select
                        name={"avgLeadDistance"}
                        value={truck.avgLeadDistance}
                        onChange={(e) => handleVehicleChange1(e, "truck")}
                        style={{ textAlign: "left" }}
                      >
                        {avgLeadDist.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>{"Avg Monthly Running"}</InputLabel>
                      <Select
                        name={"avgMonthlyRunning"}
                        value={truck.avgMonthlyRunning}
                        onChange={(e) => handleVehicleChange1(e, "truck")}
                        style={{ textAlign: "left" }}
                      >
                        {avgMonthRun.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      flexDirection: "column",
                      marginTop: "1rem",
                    }}
                  >
                    {truck?.vehicles &&
                      truck?.vehicles.map((item, idx) => (
                        <div style={{ display: "flex" }}>
                          <Typography
                            variant="h6"
                            sx={{ p: 1 }}
                            style={{ textAlign: "left", width: "50%" }}
                          >
                            {item.label}
                          </Typography>
                          <TextField
                            label={"Vehicle Count"}
                            type="text"
                            name={`${item?.name}`}
                            value={item?.count}
                            onChange={(e) => handleVehicleChange(e, "truck")}
                            fullWidth
                            onKeyPress={handleKeyPress}
                          />
                        </div>
                      ))}
                  </div>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Vehicles :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalCounttruck}
                      </Typography>
                    </div>
                    <div style={{ width: "50%", display: "flex" }}>
                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        Total Tyres :
                      </Typography>

                      <Typography
                        variant="h6"
                        sx={{ p: 1 }}
                        style={{ textAlign: "left", width: "50%" }}
                      >
                        {totalSumtruck}
                      </Typography>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>

              <Accordion style={{ margin: "1rem 0" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`lcv-content`}
                  id={`lcv-header`}
                >
                  <Typography>Retread Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr",
                      gap: "20px",
                      width: "100%",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel>Retread Pactice</InputLabel>
                      <Select
                        name={"retreadPractice"}
                        value={retreadData?.retreadPractice}
                        onChange={handleRetreadChange}
                        style={{ textAlign: "left" }}
                      >
                        {retreadPractice.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl fullWidth>
                      <InputLabel>Major tread Used</InputLabel>
                      <Select
                        name={"majorTradeUsed"}
                        value={retreadData.majorTradeUsed}
                        onChange={handleRetreadChange}
                        style={{ textAlign: "left" }}
                      >
                        {majorretread.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel>Retread Franchise</InputLabel>
                      <Select
                        name={"retreadFranchise"}
                        value={retreadData.retreadFranchise}
                        onChange={handleRetreadChange}
                        style={{ textAlign: "left" }}
                      >
                        {majorretread.map((option) => (
                          <MenuItem key={option} value={option}>
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      marginTop: "1rem",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        textAlign: "left",
                        marginRight: "2rem",
                      }}
                    >
                      Tyres Retreaded per Month
                    </Typography>
                    <TextField
                      label={"Vehicle Count"}
                      type="text"
                      name={`tyresRetreadMonth`}
                      value={retreadData?.tyresRetreadMonth}
                      onChange={handleRetreadChange}
                      // fullWidth
                      onKeyPress={handleKeyPress}
                    />
                  </div>
                </AccordionDetails>
              </Accordion>
            </>
          ) : null}
        </form>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "1.5rem",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DealerProfile;
